

export const articlesExtend = (article) => {
    if (article.metaObject && article.metaObject !== "mermeta" && article.metaObject !== "undefined" && typeof article.metaObject !== "undefined") {
        article.metaParsed = JSON.parse(decodeURIComponent(article.metaObject));
        if (article.metaParsed.currentDynamiskMalContent && article.metaParsed.currentDynamiskMalContent.length) {
            article.metaDynamic = {};
            article.metaDynamicId = {};
            article.metaParsed.currentDynamiskMalContent.forEach(cmc => {
                article.metaDynamic[cmc.title] = cmc.value;
                article.metaDynamicId[cmc.localId] = cmc.value;
            })
        }
        else {
            article.metaDynamic = false;
        }
    }
    else {
        article.metaDynamic = false;
        article.metaParsed = false;
    }

    if (article.contentObject !== "undefined") {
        article.contentParsed = decodeURIComponent(article.contentObject);
    }

    return article;
}


export const getDynamicContent = (id, object) => {
    if (object) {
        return object.filter(item => {
            return item.localId === id ? item : false;
        })[0].value;
    }
    else
        return false
}

export const findsite = () => {

    var sitename = window.site;
    return window.catergories.filter(category => {
        return urlify(category.item) === sitename ? category : false;
    })[0];

}

export const createGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};


export const getFromContent = (html, qsa) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(html, "text/html");
    let r = dom.querySelectorAll(qsa);
    return r;
}

export const postImplementImage = (callback = false, width = 450) => {
    
    // console.log("start",document.querySelectorAll(".image__unresolved").length);
    
    document.querySelectorAll(".image__unresolved").forEach(img => {
        
        // console.log("ongoing");
        
        const id = img.dataset.id;
        if(id){
            fetch(window.apiUrl + "/api/PublicContentApi/find/" + id).then(response => response.json()).then(image => {
                if (image) {
                    
                    // console.log("done");
                    image = articlesExtend(image);
                    img.alt="";
                    img.src="https://res.cloudinary.com/ssp/image/fetch/g_center,w_"+width+",f_webp,c_fill/"+image.path;
                    
                    if(callback)
                    callback();
                    
                }
            })
        }
    })
}


export const wrap = (el, elm = "div", objectchanges) => {
    let wrapper = document.createElement(elm);
    el.parentNode.insertBefore(wrapper, el);
    if(typeof objectchanges === "function"){
        wrapper = objectchanges(wrapper);
    }
    wrapper.appendChild(el);
}
